<script setup lang="ts">
import { computed, ref } from 'vue'
import { useUiStore } from '@/stores/uiStore'
import { useDocumentStore } from '@/stores/documentStore'
import { useModal } from '@/composables/useModalStack'
import { useI18n } from '@/i18n'
import { runCommand } from '@/commands/registry'

const emit = defineEmits<{ close: [] }>()
useModal('fill')
const { t } = useI18n()
const ui = useUiStore()
const use = ref<'fg' | 'bg' | 'custom' | 'pattern'>('fg')
const docStore = useDocumentStore()
const patterns = computed(() => docStore.doc?.patterns ?? [])
const patternId = ref(patterns.value[0]?.id ?? '')
const scale = ref(1)
const custom = ref(ui.foreground)
const opacity = ref(100)
function run() {
  if (use.value === 'pattern') {
    if (!patternId.value) return
    void runCommand('edit.fill', { patternId: patternId.value, scale: scale.value, opacity: opacity.value / 100 })
    emit('close')
    return
  }
  const hex = use.value === 'fg' ? ui.foreground : use.value === 'bg' ? ui.background : custom.value
  void runCommand('edit.fill', { hex, opacity: opacity.value / 100 })
  emit('close')
}
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="emit('close')">
    <div class="modal" @keydown.esc="emit('close')" @keydown.enter="run">
      <h2>{{ t('dialog.fill.title') }}</h2>
      <label class="field"><span>{{ t('dialog.fill.use') }}</span>
        <select v-model="use" autofocus>
          <option value="fg">{{ t('dialog.fill.foreground') }}</option>
          <option value="bg">{{ t('dialog.fill.background') }}</option>
          <option value="custom">{{ t('dialog.fill.custom') }}</option>
          <option value="pattern" :disabled="!patterns.length">{{ t('pattern.title') }}</option>
        </select>
      </label>
      <label v-if="use === 'custom'" class="field"><span>{{ t('dialog.fill.custom') }}</span><input v-model="custom" type="color" /></label>
      <template v-if="use === 'pattern'">
        <label class="field"><span>{{ t('pattern.title') }}</span><select v-model="patternId"><option v-for="p in patterns" :key="p.id" :value="p.id">{{ p.name }}</option></select></label>
        <label class="field"><span>{{ t('fill.scale') }}</span><span class="row"><input v-model.number="scale" type="number" min="0.05" max="10" step="0.05" /></span></label>
      </template>
      <label class="field"><span>{{ t('dialog.fill.opacity') }}</span><span class="row"><input v-model.number="opacity" type="number" min="1" max="100" /> %</span></label>
      <div class="actions">
        <button @click="emit('close')">{{ t('dialog.cancel') }}</button>
        <button class="primary" @click="run">{{ t('dialog.ok') }}</button>
      </div>
    </div>
  </div>
</template>
